import type * as store from '@attain-apps/fe/web/main/lib/store'

/**
 * Trace-stash key used to mark actions triggered by a user table refresh.
 *
 * This is intentionally owned by the table design layer so app/state features
 * can react to explicit refresh intent without coupling to action-origin
 * strings.
 */
export const REFRESH_TRACE_KEY = 'ds.tableOld.refresh'

/**
 * Trace-stash value used for {@link REFRESH_TRACE_KEY}.
 */
export const REFRESH_TRACE_VALUE = true

/**
 * Options to pass to `.from(source, options)` when dispatching a user refresh
 * action from a table UI.
 */
export const refreshTraceOptions = {
  traceStash: {
    [REFRESH_TRACE_KEY]: REFRESH_TRACE_VALUE,
  },
} as const

/**
 * Returns true when the given action was tagged as a table refresh action.
 */
export function isRefreshTriggeredAction(
  action: Pick<store.actions.Action, 'traceStash'>,
): boolean {
  return action.traceStash?.[REFRESH_TRACE_KEY] === REFRESH_TRACE_VALUE
}
